// extracted by mini-css-extract-plugin
export var animationContainer = "_nk-0";
export var footer = "_nk-1";
export var gray = "_nk-2";
export var lineItem = "_nk-3";
export var lineItemImage = "_nk-4";
export var lineItemInfo = "_nk-5";
export var lineItemText = "_nk-6";
export var lineItems = "_nk-7";
export var modalContent = "_nk-8";
export var options = "_nk-9";
export var orderName = "_nk-a";
export var refundAmount = "_nk-b";